<template>
  <div class="ucenter my-post" :class="{ nopd: isPreview }">
    <div class="topBg">
      <van-icon
        class="left_icon"
        color="#ffffff"
        name="arrow-left"
        size="32px"
        style="padding-right: 20px"
        @click="onClickLeft"
      />
      <h3>{{ detail.ProdName }}</h3>
      <div class="line"></div>
      <p>{{ detail.ProdDesc }}</p>
    </div>

    <van-tabs
      v-model:active="active"
      color="#b57e48"
      line-height="2px"
      line-width="24px"
      :sticky="true"
      title-active-color="#000000"
    >
      <van-tab title="方案介绍">
        <div class="cont_b">
          <div v-if="detail.Introduction" class="content_box">
            <div class="ql-editor" v-html="detail.Introduction"></div>
          </div>
          <div v-else style="margin-top: 60px">
            <van-empty description="暂无内容" image-size="80" />
          </div>
        </div>
      </van-tab>
      <van-tab title="经典案例">
        <article-list
          :is-preview="isPreview"
          :params="params"
          :prodid="prodId"
        />
      </van-tab>
    </van-tabs>
  </div>
</template>
<script>
  import ArticleList from '@/components/ArticleListNew'
  import { useRoute, useRouter } from 'vue-router'
  import { ref, onActivated, onMounted } from 'vue'
  import store from '@/store'
  import api from '@/api'
  export default {
    components: {
      ArticleList,
    },
    setup() {
      const route = useRoute()
      const router = useRouter()
      const active = ref(0)
      const tenant = ref(null)
      let url = ref('')
      const params = ref({})
      const detail = ref({})
      const userInfo = ref({})
      const CurrentPage = ref([])
      const isPreview = ref(route.query.preview)
      const prodId = ref('')
      onActivated(() => {
        init()
        GetDetail()
        window.scrollTo(0, 0)
        active.value = 0
      })
      const init = async () => {
        prodId.value = router.currentRoute.value.params.id
        params.value.random = Math.random()
        url.value = 'case/PostSelectMyPost'
        params.value.random = Math.random()
        userInfo.value = store.getters['user/getUserInfo']
      }
      //获取产品详情
      const GetDetail = async () => {
        tenant.value = await store.getters['user/getTenant']
        if (!prodId.value) return
        store
          .dispatch('service/GetDetail', {
            prodId: prodId.value,
            tenantId: tenant.value.TenantId,
          })
          .then((res) => {
            if (res.Code === 0) {
              //console.log('res223444 :>> ', res.Data)
              if (res.Data.Introduction) {
                res.Data.Introduction.replace(/\n/g, '<br/>')
              }

              detail.value = res.Data
            }
          })
      }
      const onClickLeft = () => {
        router.back()
      }

      //PostSelectByAuthor
      return {
        url,
        params,
        active,
        userInfo,
        api,
        isPreview,
        onClickLeft,
        GetDetail,
        tenant,
        CurrentPage,
        detail,
        prodId,
      }
    },
  }
</script>
<style lang="scss" scoped>
  ::v-deep .van-tabs--line .van-tabs__wrap {
    position: relative;
    &::after {
      position: absolute;
      content: '';
      left: 16px;
      right: 16px;
      bottom: 0;
      height: 1px;
      background: #e8e8e9;
    }
  }
  .my-post {
    position: relative;
    &.nopd {
      padding-top: 0;
    }
  }
  .van-tabs__nav--line {
    border-bottom: 1px solid #ccc !important;
  }
  .content_box {
    padding: 10px 15px;
    word-break: break-all;
    img {
      width: 640px;
    }
    div {
      font-size: 14px;
      margin-bottom: 16px;
    }
  }
  .topBg {
    height: 200px;
    background-image: linear-gradient(to right, #151627, #3a3d64);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    color: #ffffff;

    .left_icon {
      position: absolute;
      top: 75px;
      left: 6px;
    }
    h3 {
      font-size: 18px;
      font-family: 'Source Han Sans CN';
      font-weight: 400;
      font-size: 30px;
      font-weight: bold;
      width: 274px;
      overflow: hidden; /*自动隐藏文字*/
      text-overflow: ellipsis; /*文字隐藏后添加省略号*/
      white-space: nowrap; /*强制不换行*/
      text-align: center;
    }
    .line {
      width: 25px;
      height: 2px;
      background: #ffffff;
      margin: 15px 0;
    }
    p {
      font-size: 15px;
      font-family: 'Source Han Sans CN';
      font-weight: 400;
      width: 70%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      text-align: center;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
</style>
